import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class CrisisPlanDeclaredJournalEvent extends JournalEvent {
  static override type = "crisis-plan-declared-journal-event";

  @attr("date") declare crisisPlanDate: Date;

  @attr("string") declare mentalWarnings: string;

  @attr("string") declare mentalActionsToTake: string;

  @attr("string") declare mentalContacts: string;

  @attr("string") declare depressiveWarnings: string;

  @attr("string") declare depressiveActionsToTake: string;

  @attr("string") declare depressiveContacts: string;

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.crisis-plan-declared-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
  @belongsTo("patient", {
    async: false,
    inverse: "crisisPlanDeclaredJournalEvent"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "crisis-plan-declared-journal-event": CrisisPlanDeclaredJournalEvent;
  }
}
